// WLM x Globo integration (pre-render & DOM fallback filtering)
(function() {
    
    if (window.__WLM_GLOBO_UNIVERSAL_HOOKED__) return;
    window.__WLM_GLOBO_UNIVERSAL_HOOKED__ = true;
    const checkedCache = {};

    function getHandleFromProduct(product) {
        return product && (
            product.handle ||
            product.product_handle ||
            product.slug ||
            (product.url && (product.url.match(/\/products\/([^/?#]+)/) || [])[1])
        ) || null;
    }

    function checkIsProductHide(handles=[]) {
        if (!handles || !handles.length) return { products: [] };
        const results = [], pageSize = 20;
        for (let i = 0; i < handles.length; i += pageSize) {
            const url = `/search?view=wlm-api&handle=${handles.slice(i, i + pageSize).join(",")}`;
            const xhr = new XMLHttpRequest();
            try {
                xhr.open("GET", url, false);
                xhr.send();
                if (xhr.status === 200) {
                    const json = JSON.parse(xhr.responseText);
                    if (json.products) results.push(...json.products);
                }
            } catch (e) {}
        }
        return { products: results };
    }

    function filterAllowedHandlesSync(handles) {
        try {
            const { products = [] } = checkIsProductHide(handles);
            const allowed = new Set();
            for (let i = 0; i < products.length; i++) {
                const h = getHandleFromProduct(products[i]);
                if (h) allowed.add(h);
            }
            return allowed;
        } catch {
            return new Set(handles);
        }
    }

    function fetchHandlesHiddenStatusAsync(handles) {
        if (!handles || !handles.length) return;
        const uniqueMissing = [...new Set(handles.filter(h => checkedCache[h] === undefined))];
        if (!uniqueMissing.length) return;
        uniqueMissing.forEach(h => { checkedCache[h] = 'pending'; });
        const pageSize = 20;
        for (let i = 0; i < uniqueMissing.length; i += pageSize) {
            const chunk = uniqueMissing.slice(i, i + pageSize);
            const url = `/search?view=wlm-api&handle=${chunk.join(",")}`;
            originalFetch(url)
                .then(res => res.json())
                .then(json => {
                    const allowedSet = new Set();
                    if (json && json.products) {
                        json.products.forEach(p => {
                            const h = getHandleFromProduct(p);
                            if (h) allowedSet.add(h);
                        });
                    }
                    chunk.forEach(h => {
                        checkedCache[h] = allowedSet.has(h);
                    });
                    fixGlobalProductGrid();
                    fixAllPredictiveSearchPopups();
                })
                .catch(() => {
                    chunk.forEach(h => { if (checkedCache[h] === 'pending') checkedCache[h] = undefined; });
                });
        }
    }

    function deepFilterGloboData(obj) {
        let changed = false;
        if (!obj || typeof obj !== 'object') return false;
        for (const key in obj) {
            if (Array.isArray(obj[key]) && (key === 'products' || key === 'items' || key === 'results')) {
                const list = obj[key];
                const handles = list.map(getHandleFromProduct).filter(Boolean);
                if (handles.length > 0) {
                    const allowed = filterAllowedHandlesSync(handles);
                    const originalLength = list.length;
                    obj[key] = list.filter(p => allowed.has(getHandleFromProduct(p)));
                    if (obj[key].length !== originalLength) changed = true;
                }
            } else if (typeof obj[key] === 'object') {
                if (deepFilterGloboData(obj[key])) changed = true;
            }
        }
        return changed;
    }

    function filterPredictiveSearchHTML(htmlText) {
        if (!htmlText || typeof htmlText !== 'string') return htmlText;
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
            const items = doc.querySelectorAll('a[href*="/products/"], [href*="/products/"]');
            if (!items.length) return htmlText;
            const handles = [];
            items.forEach(item => {
                const href = item.getAttribute('href') || '';
                const match = href.match(/\/products\/([^/?#]+)/);
                if (match && match[1]) handles.push(match[1]);
            });
            if (handles.length > 0) {
                const allowed = filterAllowedHandlesSync(handles);
                let changed = false;
                items.forEach(item => {
                    const href = item.getAttribute('href') || '';
                    const match = href.match(/\/products\/([^/?#]+)/);
                    if (match && match[1] && !allowed.has(match[1])) {
                        const container = item.closest('li') || item.closest('[role="option"]') || item.closest('[class*="spf-col-"]') || item.closest('.resource-card') || item;
                        if (container) {
                            container.remove();
                            changed = true;
                        }
                    }
                });
                if (changed) return doc.body.innerHTML;
            }
        } catch (e) {}
        return htmlText;
    }

    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
        const requestUrl = args[0] instanceof Request ? args[0].url : args[0];
        const response = await originalFetch.apply(this, args);
        if (requestUrl && typeof requestUrl === 'string') {
            const lowerUrl = requestUrl.toLowerCase();
            if (lowerUrl.includes('globo') || lowerUrl.includes('/search/suggest') || lowerUrl.includes('section_id=predictive-search') || lowerUrl.includes('section_id=search')) {
                try {
                    const clonedResponse = response.clone();
                    const contentType = response.headers.get('content-type') || '';
                    if (contentType.includes('json')) {
                        const data = await clonedResponse.json();
                        if (deepFilterGloboData(data)) {
                            return new Response(JSON.stringify(data), {
                                status: response.status,
                                statusText: response.statusText,
                                headers: response.headers
                            });
                        }
                    } else {
                        const textData = await clonedResponse.text();
                        const filteredHtml = filterPredictiveSearchHTML(textData);
                        if (filteredHtml !== textData) {
                            return new Response(filteredHtml, {
                                status: response.status,
                                statusText: response.statusText,
                                headers: response.headers
                            });
                        }
                    }
                } catch (e) {}
            }
        }
        return response;
    };

    try {
        const originalOpen = window.XMLHttpRequest.prototype.open;
        window.XMLHttpRequest.prototype.open = function(method, url) {
            this._url = url;
            return originalOpen.apply(this, arguments);
        };
        const originalResponseTextGetter = Object.getOwnPropertyDescriptor(window.XMLHttpRequest.prototype, 'responseText')?.get;
        if (originalResponseTextGetter) {
            Object.defineProperty(window.XMLHttpRequest.prototype, 'responseText', {
                get: function() {
                    const originalText = originalResponseTextGetter.call(this);
                    if (this._url && typeof this._url === 'string') {
                        const lowerUrl = this._url.toLowerCase();
                        if ((lowerUrl.includes('globo') || lowerUrl.includes('/search/suggest') || lowerUrl.includes('section_id=')) && this.readyState === 4 && this.status === 200) {
                            if (this._wlmFilteredText) return this._wlmFilteredText;
                            try {
                                if (originalText.trim().startsWith('{') || originalText.trim().startsWith('[')) {
                                    let data = JSON.parse(originalText);
                                    if (deepFilterGloboData(data)) {
                                        this._wlmFilteredText = JSON.stringify(data);
                                        return this._wlmFilteredText;
                                    }
                                } else {
                                    let filteredHtml = filterPredictiveSearchHTML(originalText);
                                    if (filteredHtml !== originalText) {
                                        this._wlmFilteredText = filteredHtml;
                                        return this._wlmFilteredText;
                                    }
                                }
                            } catch (e) {}
                        }
                    }
                    return originalText;
                },
                configurable: true
            });
        }
    } catch (xhrErr) {}

    try {
        window.addEventListener("globoFilterSearchCompleted", function(ev) {
            try {
                const payload = ev && (ev.detail || ev);
                if (!payload || !payload.result || !Array.isArray(payload.result.products)) return;
                const list = payload.result.products;
                const handles = list.map(getHandleFromProduct).filter(Boolean);
                if (!handles.length) return;
                const allowed = filterAllowedHandlesSync(handles);
                payload.result.products = list.filter(p => allowed.has(getHandleFromProduct(p)));
            } catch {}
        }, { passive: false });
    } catch {}

    function tryPatchTransform() {
        const gf = window.globofilter;
        if (!gf || typeof gf.transformProducts !== "function") return false;
        if (gf.__wlmTransformPatched) return true;
        const originalTransform = gf.transformProducts.bind(gf);
        gf.transformProducts = function(products) {
            try {
                if (Array.isArray(products) && products.length) {
                    const handles = products.map(getHandleFromProduct).filter(Boolean);
                    if (handles.length) {
                        const allowed = filterAllowedHandlesSync(handles);
                        products = products.filter(p => allowed.has(getHandleFromProduct(p)));
                    }
                }
            } catch {}
            return originalTransform(products);
        };
        gf.__wlmTransformPatched = true;
        return true;
    }

    if (!tryPatchTransform()) {
        const timer = setInterval(() => { tryPatchTransform() && clearInterval(timer); }, 100);
        setTimeout(() => clearInterval(timer), 10000);
    }

    // Global selector scanning logic covering storefront collection pages & search results grids
    function fixGlobalProductGrid() {
        const productLinks = document.querySelectorAll('a[href*="/products/"]');
        const handlesToFetch = [];

        productLinks.forEach(link => {
            const href = link.getAttribute('href') || '';
            const match = href.match(/\/products\/([^/?#]+)/);
            if (!match || !match[1]) return;
            const handle = match[1];

            if (checkedCache[handle] === false) {
                // Targets Globo specific grid column columns and classic layout wrappers
                const container = link.closest('[class*="spf-col-"]') || 
                                  link.closest('.grid__item') || 
                                  link.closest('li') || 
                                  link.closest('.spf-product-card') || 
                                  link;
                if (container && container.style.display !== 'none') {
                    container.style.setProperty('display', 'none', 'important');
                }
            } else if (checkedCache[handle] === undefined) {
                handlesToFetch.push(handle);
            }
        });

        if (handlesToFetch.length > 0) {
            fetchHandlesHiddenStatusAsync(handlesToFetch);
        }
    }

    function fixAllPredictiveSearchPopups() {
        const targetItems = document.querySelectorAll(
            '.predictive-search__list-item, .predictive-search__item, ' +
            '.predictive-search-results__card, .resource-card, product-card-link'
        );
        if (!targetItems.length) return;
        const handlesToFetch = [];
        const itemsToProcess = [];
        targetItems.forEach(item => {
            const isInsideSearch = item.closest('predictive-search-component, predictive-search, .predictive-search, [id*="predictive-search"], [class*="search-modal"]');
            if (!isInsideSearch) return;
            let urlString = '';
            let innerLink = item.tagName === 'A' ? item : item.querySelector('a[href*="/products/"]');
            if (innerLink && innerLink.href) {
                urlString = innerLink.href;
            } else if (item.getAttribute('href') && item.getAttribute('href').includes('/products/')) {
                urlString = item.getAttribute('href');
                innerLink = item;
            }
            if (!urlString) return;
            const match = urlString.match(/\/products\/([^/?#]+)/);
            if (match && match[1]) {
                const handle = match[1];
                itemsToProcess.push({ wrapper: item, handle: handle, linkElement: innerLink });
                if (checkedCache[handle] === undefined) {
                    handlesToFetch.push(handle);
                }
            }
        });
        if (handlesToFetch.length > 0) {
            fetchHandlesHiddenStatusAsync(handlesToFetch);
        }
        itemsToProcess.forEach(item => {
            const isWlmHidden = item.linkElement && item.linkElement.style.display === 'none';
            if (checkedCache[item.handle] === false || isWlmHidden) {
                const topCardWrapper = item.wrapper.closest('.predictive-search-results__card') ||
                    item.wrapper.closest('.predictive-search__list-item') ||
                    item.wrapper.closest('li') ||
                    item.wrapper;
                if (topCardWrapper && topCardWrapper.style.display !== 'none') {
                    topCardWrapper.style.setProperty('display', 'none', 'important');
                }
            }
        });
    }

    const domObserver = new MutationObserver((mutations) => {
        let linksToScan = false;
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length || mutation.type === 'attributes') {
                linksToScan = true;
            }
        });
        if (linksToScan) {
            fixGlobalProductGrid();
            fixAllPredictiveSearchPopups();
        }
    });

    domObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['href', 'open', 'results', 'style']
    });

    fixGlobalProductGrid();
    fixAllPredictiveSearchPopups();
    window.addEventListener('load', () => {
        fixGlobalProductGrid();
        fixAllPredictiveSearchPopups();
    });
    
    setInterval(fixAllPredictiveSearchPopups, 200);
    setInterval(fixGlobalProductGrid, 300);
})();